"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTCard = void 0;
const react_1 = __importDefault(require("react"));
const schemas_1 = require("@dcl/schemas");
const NFTCard_1 = require("decentraland-ui/dist/components/NFTCard/NFTCard");
const utils_1 = require("../../modules/translation/utils");
const NFTCard = (props) => {
    const i18n = {
        network: {
            [schemas_1.Network.ETHEREUM]: 'Ethereum',
            [schemas_1.Network.MATIC]: 'Polygon'
        },
        bodyShape: {
            male: (0, utils_1.t)('@dapps.nft_card.body_shape.male'),
            female: (0, utils_1.t)('@dapps.nft_card.body_shape.female'),
            unisex: (0, utils_1.t)('@dapps.nft_card.body_shape.unisex')
        },
        playMode: {
            loop: (0, utils_1.t)('@dapps.nft_card.play_mode.loop'),
            once: (0, utils_1.t)('@dapps.nft_card.play_mode.once')
        },
        category: {
            [schemas_1.WearableCategory.EYEBROWS]: (0, utils_1.t)('@dapps.nft_card.category.eyebrows'),
            [schemas_1.WearableCategory.EYES]: (0, utils_1.t)('@dapps.nft_card.category.eyes'),
            [schemas_1.WearableCategory.FACIAL_HAIR]: (0, utils_1.t)('@dapps.nft_card.category.facial_hair'),
            [schemas_1.WearableCategory.HAIR]: (0, utils_1.t)('@dapps.nft_card.category.hair'),
            [schemas_1.WearableCategory.BODY_SHAPE]: (0, utils_1.t)('@dapps.nft_card.category.body_shape'),
            [schemas_1.WearableCategory.MOUTH]: (0, utils_1.t)('@dapps.nft_card.category.mouth'),
            [schemas_1.WearableCategory.UPPER_BODY]: (0, utils_1.t)('@dapps.nft_card.category.upper_body'),
            [schemas_1.WearableCategory.LOWER_BODY]: (0, utils_1.t)('@dapps.nft_card.category.lower_body'),
            [schemas_1.WearableCategory.FEET]: (0, utils_1.t)('@dapps.nft_card.category.feet'),
            [schemas_1.WearableCategory.EARRING]: (0, utils_1.t)('@dapps.nft_card.category.earring'),
            [schemas_1.WearableCategory.EYEWEAR]: (0, utils_1.t)('@dapps.nft_card.category.eyewear'),
            [schemas_1.WearableCategory.HAT]: (0, utils_1.t)('@dapps.nft_card.category.hat'),
            [schemas_1.WearableCategory.HELMET]: (0, utils_1.t)('@dapps.nft_card.category.helmet'),
            [schemas_1.WearableCategory.MASK]: (0, utils_1.t)('@dapps.nft_card.category.mask'),
            [schemas_1.WearableCategory.TIARA]: (0, utils_1.t)('@dapps.nft_card.category.tiara'),
            [schemas_1.WearableCategory.TOP_HEAD]: (0, utils_1.t)('@dapps.nft_card.category.top_head'),
            [schemas_1.WearableCategory.SKIN]: (0, utils_1.t)('@dapps.nft_card.category.skin'),
            [schemas_1.WearableCategory.HANDS_WEAR]: (0, utils_1.t)('@dapps.nft_card.category.hands_wear')
        },
        withSound: (0, utils_1.t)('@dapps.nft_card.with_sound'),
        smart: (0, utils_1.t)('@dapps.nft_card.smart')
    };
    return react_1.default.createElement(NFTCard_1.NFTCard, Object.assign({ i18n: i18n }, props));
};
exports.NFTCard = NFTCard;
//# sourceMappingURL=NFTCard.js.map